module.exports = __webpack_public_path__ + "img/logo.60c86561.svg";